(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-header"]) return;
  try {
    
  (function () {
    function initHeader() {
      var header = document.querySelector('[data-aw-header]');
      if (!header || header.dataset.awReady) return;
      header.dataset.awReady = '1';

      var ann = document.querySelector('[data-aw-ann]');
      function setTop() { document.documentElement.style.setProperty('--aw-sticky-top', ann ? -ann.offsetHeight + 'px' : '0px'); }
      setTop(); window.addEventListener('resize', setTop);
      window.addEventListener('scroll', function () { header.classList.toggle('is-scrolled', window.scrollY > 8); }, { passive: true });

      var nav = header.querySelector('[data-aw-tubenav]');
      if (nav) {
        var tube = nav.querySelector('.aw-tube');
        var links = [].slice.call(nav.querySelectorAll('a'));
        var idx = parseInt(nav.dataset.active, 10) || 0;
        var active = idx > 0 ? links[idx - 1] : null;
        var moveTo = function (a) {
          if (!a) { tube.classList.remove('on'); return; }
          tube.style.width = a.offsetWidth + 'px';
          tube.style.transform = 'translateX(' + a.offsetLeft + 'px)';
          tube.classList.add('on');
        };
        links.forEach(function (a) {
          a.addEventListener('mouseenter', function () { moveTo(a); });
          a.addEventListener('focus', function () { moveTo(a); });
        });
        nav.addEventListener('mouseleave', function () { moveTo(active); });
        window.addEventListener('resize', function () { moveTo(active); });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveTo(active); }); else moveTo(active);
      }

      var drawer = document.querySelector('[data-aw-drawer]');
      var openBtn = header.querySelector('[data-aw-open]');
      if (drawer && openBtn) {
        var setOpen = function (o) {
          drawer.classList.toggle('open', o);
          drawer.setAttribute('aria-hidden', o ? 'false' : 'true');
          openBtn.setAttribute('aria-expanded', o ? 'true' : 'false');
          document.documentElement.style.overflow = o ? 'hidden' : '';
          if (o) drawer.querySelector('.aw-close').focus();
        };
        openBtn.addEventListener('click', function () { setOpen(true); });
        drawer.querySelectorAll('[data-aw-close]').forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) setOpen(false); });
      }

      /* Cart icon opens the cart drawer instead of the cart page (the page stays the fallback) */
      function cartDrawer() { var d = document.getElementById('cart-drawer'); return d && typeof d.open === 'function' ? d : null; }
      if (header.dataset.cartDrawer === 'true') {
        var cartLink = header.querySelector('[data-aw-cart]');
        if (cartLink) cartLink.addEventListener('click', function (e) { var d = cartDrawer(); if (d) { e.preventDefault(); d.open(); } });
        /* "oder in den Warenkorb" on the product page comes back with ?aw_cart=open */
        if (/[?&]aw_cart=open/.test(window.location.search)) {
          var tries = 0;
          (function tryOpen() {
            var d = cartDrawer();
            if (d) {
              d.open();
              var u = new URL(window.location.href); u.searchParams.delete('aw_cart');
              window.history.replaceState({}, '', u);
            } else if (tries++ < 50) setTimeout(tryOpen, 100);
          })();
        }
      }

      /* While Shopify's cookie banner is open, the product page buy bar moves up above it */
      if (header.dataset.cookieGlass === 'true') {
        var root = document.documentElement, seen = false, started = Date.now();
        var iv = setInterval(function () {
          var b = document.querySelector('#shopify-pc__banner .shopify-pc__banner__dialog');
          var r = b ? b.getBoundingClientRect() : null;
          var vis = !!(r && r.height > 0 && getComputedStyle(b).visibility !== 'hidden');
          if (vis) { seen = true; root.style.setProperty('--aw-cookie-h', Math.round(r.height) + 'px'); }
          root.classList.toggle('aw-cookie-on', vis);
          if ((seen && !vis) || (!seen && Date.now() - started > 20000)) clearInterval(iv);
        }, 700);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader); else initHeader();
    document.addEventListener('shopify:section:load', initHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPdp(root) {
      root = root || document;
      var pdp = root.querySelector('[data-aw-pdp]');
      if (!pdp || pdp.dataset.awReady) return;
      pdp.dataset.awReady = '1';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var track = pdp.querySelector('.aw-g-main');
      var thumbs = [].slice.call(pdp.querySelectorAll('.aw-g-thumb'));
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = +t.dataset.index;
          track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      if (track && thumbs.length) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        }, { passive: true });
      }

      var qty = pdp.querySelector('input[name="quantity"]');
      pdp.querySelectorAll('[data-aw-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) + (+b.dataset.awQty)); });
      });

      var idInput = pdp.querySelector('[data-aw-variant-id]');
      var atc = pdp.querySelector('[data-aw-atc]');
      var stickyBtn = pdp.querySelector('[data-aw-sticky-btn]');
      var cartLink = pdp.querySelector('[data-aw-cart-link]');
      pdp.querySelectorAll('input[name="aw-variant"]').forEach(function (r) {
        r.addEventListener('change', function () {
          idInput.value = r.value;
          pdp.querySelector('[data-aw-now]').textContent = r.dataset.price;
          var sp = pdp.querySelector('[data-aw-sticky-price]'); if (sp) sp.textContent = r.dataset.price;
          var was = pdp.querySelector('[data-aw-was]'); if (was) was.textContent = r.dataset.was;
          pdp.querySelector('[data-aw-unit]').textContent = r.dataset.unit;
          var ok = r.dataset.available === 'true';
          atc.disabled = !ok; if (stickyBtn) stickyBtn.disabled = !ok; if (cartLink) cartLink.disabled = !ok;
          var url = new URL(window.location.href); url.searchParams.set('variant', r.value);
          window.history.replaceState({}, '', url);
        });
      });

      var del = pdp.querySelector('[data-aw-delivery]');
      if (del) {
        var min = +del.dataset.min || 2, max = +del.dataset.max || 4, cutoff = +del.dataset.cutoff || 14;
        var addWorkdays = function (d, n) {
          var r = new Date(d);
          while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
          return r;
        };
        var now = new Date(), start = new Date(now);
        if (now.getHours() >= cutoff || now.getDay() === 0 || now.getDay() === 6) start = addWorkdays(now, 1);
        var f = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
        var a = addWorkdays(start, min), b = addWorkdays(start, max);
        del.querySelector('[data-aw-delivery-text]').textContent = 'Lieferung voraussichtlich ' + f.format(a) + ' – ' + f.format(b);
        var shipEl = pdp.querySelector('[data-aw-track-ship]'), endEl = pdp.querySelector('[data-aw-track-end]');
        if (shipEl) shipEl.textContent = 'Versand ' + (start.toDateString() === now.toDateString() ? 'heute' : f.format(start));
        if (endEl) endEl.textContent = 'Bei dir ab ' + f.format(a);
      }

      var sticky = pdp.querySelector('[data-aw-sticky]');
      if (sticky && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('on', out);
          sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
          stickyBtn.tabIndex = out ? 0 : -1;
        }).observe(atc);
        stickyBtn.addEventListener('click', function () { atc.click(); });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initPdp(); }); else initPdp();
    document.addEventListener('shopify:section:load', function (e) { initPdp(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
